export default __webpack_public_path__ + "static/media/hero_4000.cea164d6.jpg";